export class DefaultCategoryImageWebSide {
    public static categories = [
        {
            category: {
                name: 'performing_arts',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'abandoned-ancient-antique-672630.jpg',
                            'abstract-architectural-architecture-161043.jpg',
                            'ancient-art-artist-309700.jpg',
                            'ancient-architecture-art-236508.jpg',
                            'art-ball-ball-shaped-235615.jpg',
                            'abstract-art-artistic-935785.jpg',
                            'art-artist-artistic-316465.jpg',
                            'art-art-materials-background-1191710.jpg',
                            'architecture-building-circular-39656.jpg',
                            'abstract-abstract-photo-architectural-1029612.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Play',
                        defaultImage: [
                            'audience-auditorium-back-view-713149.jpg',
                            'adult-black-and-white-concert-167523.jpg',
                            'audience-band-concert-127712.jpg',
                            'audience-concert-lights-1150836.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Musical',
                        defaultImage: [
                            'audience-auditorium-back-view-713149.jpg',
                            'adult-black-and-white-concert-167523.jpg',
                            'audience-band-concert-127712.jpg',
                            'audience-concert-lights-1150836.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Dance',
                        defaultImage: [
                            'active-adult-artist-358010.jpg',
                            'adult-ballerina-ballet-358024.jpg',
                            'action-adult-dance-270837.jpg',
                            'adult-art-ballerina-209948.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Recitals',
                        defaultImage: [
                            'active-adult-artist-358010.jpg',
                            'adult-ballerina-ballet-358024.jpg',
                            'action-adult-dance-270837.jpg',
                            'adult-art-ballerina-209948.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Ballet',
                        defaultImage: [
                            'active-adult-artist-358010.jpg',
                            'adult-ballerina-ballet-358024.jpg',
                            'action-adult-dance-270837.jpg',
                            'adult-art-ballerina-209948.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Theather',
                        defaultImage: [
                            'pexels-photo-713149.jpeg',
                            'staging-258631__480.jpg',
                            'chicago-94510__480.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Theatre',
                        defaultImage: [
                            'pexels-photo-713149.jpeg',
                            'staging-258631__480.jpg',
                            'chicago-94510__480.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'art',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'abstract-art-art-gallery-297394.jpg',
                            'art-black-and-white-display-914186.jpg',
                            'art-artist-brush-102127.jpg',
                            'art-color-colors-9403.jpg',
                            'adult-art-artist-374009.jpg',
                            'abstract-art-artistic-226589.jpg',
                            'artistic-bright-colorful-1174932.jpg',
                            'abstract-art-artistic-459301.jpg',
                            'artist-artistic-creativity-1203998.jpg',
                            'abstract-abstract-expressionism-abstract-painting-1161771.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'comedy',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'abandoned-ancient-antique-672630.jpg',
                            'abstract-architectural-architecture-161043.jpg',
                            'ancient-art-artist-309700.jpg',
                            'artist-circus-clown-476.jpg',
                            'adult-beard-black-and-white-543.jpg',
                            'architecture-bar-buildings-219095.jpg',
                            'bright-building-business-375888.jpg',
                            'audience-band-blur-597056.jpg',
                            'daughter-family-fun-35024.jpg',
                            'audio-band-black-and-white-9137.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'music',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'adult-audience-blur-976863.jpg',
                            'abstract-abstract-painting-art-1193743.jpg',
                            'close-up-music-musical-instrument-164794.jpg',
                            'abstract-art-artistic-251287.jpg',
                            'adult-audience-band-219101.jpg',
                            'abstract-curve-design-911738.jpg',
                            '2018-abstract-art-285173.jpg',
                            'acoustic-antique-art-290660.jpg',
                            'hand-hands-music-210907.jpg',
                            'abstract-art-color-887349.jpg',
                            'abstract-art-background-1037992.jpg',
                            'abstract-art-attractive-908294.jpg',
                            'band-beat-black-and-white-65717.jpg',
                            'blue-water-blur-close-up-1231622.jpg',
                            'abstract-art-artistic-806408.jpg',
                            'abstract-art-artistic-1212408.jpg',
                            'artist-crowd-focused-34687.jpg',
                            'abstract-art-blur-417458.jpg',
                            'abstract-art-blur-850401.jpg',
                            'abstract-art-board-889839.jpg',
                            'blur-bowed-stringed-instrument-close-up-1029411.jpg',
                            'abstract-art-background-159027.jpg',
                            'abstract-art-berlin-6739.jpg',
                            'abstract-art-berlin-6739.jpg',
                            'audio-band-mixing-panel-3096.jpg',
                            'abstract-clean-close-up-705395.jpg',
                            'black-and-white-blur-book-164821.jpg',
                            'blur-bowed-stringed-instrument-classic-237454.jpg',
                            'applause-audience-band-196652.jpg',
                            'abstract-art-curve-1191244.jpg',
                            'art-black-and-white-blur-39348.jpg',
                            'art-bright-celebration-900102.jpg',
                            'audience-back-view-band-442540.jpg',
                            'art-artistic-black-and-white-959314.jpg',
                            'abstract-art-brick-wall-63952.jpg',
                            'art-artistic-black-background-1092372.jpg',
                            'band-e-guitar-guitar-3092.jpg',
                            'art-blur-bright-459689.jpg',
                            'abstract-art-colorful-942317.jpg',
                            'art-blur-bright-289756.jpg',
                            'abstract-art-ball-shaped-332824.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Live',
                        defaultImage: [
                            'action-adult-artist-354305.jpg',
                            'band-bass-concert-210794.jpg',
                            'adult-artist-audience-1047930.jpg',
                            'adult-artist-band-167445.jpg',
                            'pexels-photo-952422.jpeg',
                            'pexels-photo-756242.jpeg',
                            'pexels-photo-210922.jpeg',
                            'pexels-photo-258732.jpeg',
                            'pexels-photo-354304.jpeg',
                            'applause-audience-band-196652.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'festivals_parades',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'adult-art-beautiful-612977.jpg',
                            '4th-of-july-blur-bokeh-450301.jpg',
                            'colorful-colourful-cupcakes-587739.jpg',
                            'assortment-bright-candy-1043519.jpg',
                            'abstract-adult-animal-1022487.jpg',
                            'blurred-background-celebration-crowd-1204056.jpg',
                            'bouquet-commerce-daylight-1103063.jpg',
                            'adorable-adult-baby-838877.jpg',
                            'bazaar-blur-carnival-225238.jpg',
                            'art-artistic-bazaar-318238.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Food',
                        defaultImage: [
                            'barbecue-bbq-beef-533325.jpg',
                            'blur-bottle-bread-287354.jpg',
                            'barbecue-bbq-chicken-8572.jpg',
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Music',
                        defaultImage: [
                            'audience-concert-crowd-167591.jpg',
                            'audience-celebration-clouds-920888.jpg',
                            'band-cheering-concert-12574.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Art',
                        defaultImage: [
                            'argentina-bazaar-buenos-aires-1060803.jpg',
                            'celebration-crowd-daylight-1157557.jpg',
                            'architecture-art-gallery-cornices-34633.jpg',
                            'art-artistic-colors-1154198.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Car show',
                        defaultImage: [
                            'automobiles-bmw-car-show-682484.jpg',
                            'aerial-aerial-shot-aerial-view-753876.jpg',
                            'auto-show-automobiles-automotives-248687.jpg',
                            'asphalt-auto-automobile-164634.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'movies_film',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'action-clapper-film-director-1117132.jpg',
                            'camera-canon-cinematography-274959.jpg',
                            'close-up-female-film-1161934.jpg',
                            'film-movie-old-2990.jpg',
                            'auditorium-chairs-cinema-257385.jpg',
                            'abstract-analog-art-390089.jpg',
                            'cinema-food-movie-theater-33129.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'food',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'adult-alcohol-blur-374073.jpg',
                            'adult-bread-breakfast-280121.jpg',
                            'blur-breakfast-chef-262978.jpg',
                            'cheese-cooking-delicious-365459.jpg',
                            'blur-close-up-cutlery-370984.jpg',
                            'alcohol-blur-cuisine-390403.jpg',
                            'alcohol-bar-blur-313715.jpg',
                            'basil-dinner-dish-64208.jpg',
                            'adult-black-cafe-1068533.jpg',
                            'blur-blurred-background-breakfast-693267.jpg',
                            'appetizer-blur-close-up-806361.jpg',
                            'alcohol-beverage-bottle-374877.jpg',
                            'box-close-up-container-1122160.jpg',
                            'blur-close-up-cutlery-370984.jpg',
                            'chairs-contemporary-design-271696.jpg',
                            'adult-alcoholic-beverage-bar-127431.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Breakfast',
                        defaultImage: [
                            'beverage-breakfast-coffee-253419.jpg',
                            'blur-breakfast-chef-262978.jpg',
                            'black-coffee-close-up-coffee-196651.jpg',
                            'blow-breakfast-cheese-723031.jpg',
                            'appetizing-bread-breakfast-357573.jpg',
                            'berries-berry-blueberries-566564.jpg',
                            'bacon-biscuit-breakfast-139746.jpg',
                            'breakfast-coffee-delicious-1120858.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Farmer\'s Market',
                        defaultImage: [
                            'assorted-blurred-background-booth-868110.jpg',
                            'assorted-assortment-booth-375897.jpg',
                            'abundance-bazaar-biscuits-375904.jpg',
                            'assorted-bananas-booth-796580.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Wine',
                        defaultImage: [
                            'pexels-photo-66636.jpeg',
                            'pexels-photo-121191.jpeg',
                            'pexels-photo-1123260.jpeg',
                            'pexels-photo-374809.jpeg',
                            'pexels-photo-696219.jpeg',
                            'pexels-photo-87224.jpeg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'books',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'bookcase-books-bookshelves-256541.jpg',
                            'blur-book-browse-256546.jpg',
                            'blur-blurred-book-46274.jpg',
                            'apple-books-close-up-261768.jpg',
                            'antique-blank-camera-269810.jpg',
                            'black-and-white-book-literature-34068.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'attractions',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'art-black-and-white-exhibition-21264.jpg',
                            'adult-attractive-beautiful-207783.jpg',
                            'art-artistic-beautiful-311458.jpg',
                            'abstract-art-artistic-673648.jpg',
                            'art-cogs-colorful-171198.jpg',
                            'abandoned-ancient-antique-672630.jpg',
                            'abstract-alone-art-413268.jpg',
                            'abstract-antelope-canyon-arid-342005.jpg',
                            'close-up-dew-dewdrops-216661.jpg',
                            'abstract-art-beautiful-1058284.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'other',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'pexels-photo-1020315.jpeg',
                            'abstract-architecture-art-1097065.jpg',
                            'pexels-photo-430207.jpeg',
                            'awesome-celebration-child-6105.jpg',
                            'art-contemporary-decor-1058770.jpg',
                            'achievement-break-business-688668.jpg',
                            'adult-african-afro-1059112.jpg',
                            'achievement-arts-and-crafts-business-951236.jpg',
                            'art-balloons-bright-1193600.jpg',
                            'adult-art-beanie-736603.jpg',
                            'art-chess-color-209651.jpg',
                            'architecture-art-building-270859.jpg',
                            'art-beautiful-beauty-922625.jpg',
                            'art-bicycle-bike-198327.jpg',
                            'adult-beard-cement-845434.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'outdoors_recreation',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'artistic-blossom-bright-207962.jpg',
                            'beautiful-beauty-blur-356185.jpg',
                            'girl-walking-wall-32246.jpg',
                            'blue-sky-clouds-flying-55787.jpg',
                            'backlit-clouds-dawn-415380.jpg',
                            'flora-flowers-grass-268261.jpg',
                            'background-beam-beautiful-33707.jpg',
                            'adorable-black-and-white-blur-260175.jpg',
                            'chatting-cups-dog-745045.jpg',
                            'casual-contemporary-creativity-964567.jpg',
                            'beautiful-blur-blurred-background-794494.jpg',
                            'atmosphere-blue-cloudiness-479820.jpg',
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Fishing',
                        defaultImage: [
                            'activity-adult-bait-294674.jpg',
                            'active-activity-catch-39854.jpg',
                            'bait-fisherman-fishing-2542.jpg',
                            'bay-beach-bicycle-349727.jpg',
                            'boat-fisherman-fishing-63642.jpg',
                            'adult-fisherman-fishing-1143926.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Biking',
                        defaultImage: [
                            'bicycle-bicyclist-bike-128202.jpg',
                            'bicycle-bike-cycling-38296.jpg',
                            'action-athletes-bicycles-248559.jpg',
                            'action-active-activity-203555.jpg',
                            'active-adventure-bike-163491.jpg',
                            'athlete-bicycle-bike-48598.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Hiking',
                        defaultImage: [
                            'accomplishment-adult-adventure-372098.jpg',
                            'adventure-albay-clouds-672358.jpg',
                            'adventure-alps-climb-314703.jpg',
                            'adventure-beauty-blonde-hair-725255.jpg',
                            'adventure-climb-climber-235837.jpg',
                            'adventure-backpack-backpacker-597323.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Camping',
                        defaultImage: [
                            'bonfire-camp-campfire-1061640.jpg',
                            'camping-grass-landscape-112378.jpg',
                            'adventure-camping-feet-6757.jpg',
                            'adventure-backlit-camper-776117.jpg',
                            'activity-adult-barbecue-344102.jpg',
                            'burn-burning-campfire-134073.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Basketball',
                        defaultImage: [
                            'action-backboard-ball-358042.jpg',
                            'action-athletes-audience-269948.jpg',
                            'basketball-hoop-black-and-white-board-538694.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Baseball',
                        defaultImage: [
                            'action-athletes-ball-159741.jpg',
                            'athlete-baseball-baseball-player-163408.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Boxing',
                        defaultImage: [
                            'action-adult-athlete-598664.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Cycling',
                        defaultImage: [
                            'bicycle-bicyclist-bike-128202.jpg',
                            'action-active-activity-386024.jpg',
                            'action-adults-adventure-248547.jpg',
                            'athlete-bike-black-and-white-260409.jpg',
                            'art-bicycle-bike-623919.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Exercise',
                        defaultImage: [
                            'active-adult-athlete-863977.jpg',
                            'adult-aerobics-athlete-863974.jpg',
                            'active-activity-adult-863926.jpg',
                            'active-activity-adults-424725.jpg',
                            'enjoyment-facial-expression-fashion-1089147.jpg',
                            'active-aerobics-asian-869243.jpg',
                            'bright-close-up-color-221247.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'football',
                        defaultImage: [
                            'athlete-ball-catching-2207.jpg',
                            'action-american-football-athlete-207710.jpg',
                            'american-football-athletes-ball-159571.jpg',
                            'american-football-athlete-ball-163328.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Golf',
                        defaultImage: [
                            'activity-adult-ball-274263.jpg',
                            'activity-bunker-club-274262.jpg',
                            'game-golf-golf-club-163321.jpg',
                            'active-activity-adults-424725.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Run',
                        defaultImage: [
                            'action-athlete-athletics-618612.jpg',
                            'endurance-exercise-female-40751.jpg',
                            'dawn-dusk-exercise-347134.jpg',
                            'community-fun-group-13918.jpg',
                            'stock-photo-sport-running-jogging-run-shoe-jog-athlete-wellness-workout-57c7ea66-c573-449e-814b-b7e6468b41fd.jpg'
                        ],
                        index: 0
                    },
                    // {
                    //     keyword: 'Running',
                    //     defaultImage: [
                    //         'action-athlete-athletics-618612.jpg',
                    //         'endurance-exercise-female-40751.jpg',
                    //         'dawn-dusk-exercise-347134.jpg',
                    //         'community-fun-group-13918.jpg',
                    //         'stock-photo-sport-running-jogging-run-shoe-jog-athlete-wellness-workout-57c7ea66-c573-449e-814b-b7e6468b41fd.jpg'
                    //     ],
                    //     index: 0
                    // },
                    {
                        keyword: 'Soccer',
                        defaultImage: [
                            'athletes-field-football-532805.jpg',
                            'athlete-athletes-ball-258395.jpg',
                            'action-action-energy-american-football-906073.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Rock Climbing',
                        defaultImage: [
                            'action-adventure-challenge-449609.jpg',
                            'backpack-daylight-daytime-906013.jpg',
                            'action-active-athlete-419293.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Snow Skiing',
                        defaultImage: [
                            'action-athlete-athletes-848618.jpg',
                            'action-adventure-blue-skies-851095.jpg',
                            'equipment-ice-ski-376697.jpg',
                            'cold-daylight-enjoyment-848712.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Snowboarding',
                        defaultImage: [
                            'action-athlete-athletes-848618.jpg',
                            'action-adventure-blue-skies-851095.jpg',
                            'equipment-ice-ski-376697.jpg',
                            'cold-daylight-enjoyment-848712.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Swim',
                        defaultImage: [
                            'blue-competition-competitors-56837.jpg',
                            'action-blue-diver-863988.jpg',
                            'splash-sport-swimmer-73760.jpg',
                            'bald-goggles-leisure-50596.jpg'
                        ],
                        index: 0
                    },
                    // {
                    //     keyword: 'swimming',
                    //     defaultImage: [
                    //         'blue-competition-competitors-56837.jpg',
                    //         'action-blue-diver-863988.jpg',
                    //         'splash-sport-swimmer-73760.jpg',
                    //         'bald-goggles-leisure-50596.jpg'
                    //     ],
                    //     index: 0
                    // }
                    {
                        keyword: 'Tennis',
                        defaultImage: [
                            'pexels-photo-341003.jpeg',
                            'person-woman-sport-ball.jpg',
                            'action-active-activity-1103829.jpg',
                            'action-adult-athlete-342360.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Doubles',
                        defaultImage: [
                            'pexels-photo-341003.jpeg',
                            'person-woman-sport-ball.jpg',
                            'action-active-activity-1103829.jpg',
                            'action-adult-athlete-342360.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Yoga',
                        defaultImage: [
                            'fitness-girl-hands-374694.jpg',
                            'agility-balance-beautiful-girl-12343.jpg',
                            'active-activity-athletic-40974.jpg',
                            'active-aerobic-aerobics-917732.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Sailing',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Yatch',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Boating',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Volleyball',
                        defaultImage: [
                            'volleyball-520093_1280.jpg',
                            'volleyball-1604584_1280.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Cheerleading',
                        defaultImage: [
                            'cheerleaders-654359_1280.jpg',
                            'cheerleaders-654381_1280.jpg'
                        ],
                        index: 0
                    },
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'holiday',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'pexels-photo-450301.jpeg',
                            'pexels-photo-461917.jpeg',
                            'backlit-bonding-casual-708392.jpg',
                            'crowd-festival-fun-1204061.jpg',
                            'action-adventure-blur-386009.jpg',
                            'blur-chair-cheerful-160739.jpg',
                            'abstract-art-balloons-221361.jpg',
                            'adolescent-adult-beautiful-618544.jpg',
                            'architecture-beach-booth-373328.jpg',
                            'alcohol-alcoholic-cocktail-34211.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Christmas',
                        defaultImage: [
                            'celebration-christmas-christmas-balls-250177.jpg',
                            '2018-bright-celebration-285598.jpg',
                            'christmas-christmas-wallpaper-holiday-280204.jpg',
                            'adult-background-beard-716658.jpg',
                            'architecture-buildings-bulgaria-735809.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Halloween',
                        defaultImage: [
                            '4th-of-july-american-bright-461917.jpg',
                            'agriculture-autumn-farm-164158.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Thanksgiving',
                        defaultImage: [
                            'art-birds-business-260487.jpg',
                            'bowl-broth-cooking-209540.jpg',
                            'chicken-close-up-dinner-265393.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'New Years',
                        defaultImage: [
                            '4th-of-july-american-bright-461917.jpg',
                            'agriculture-autumn-farm-164158.jpg',
                            'bright-celebration-explosion-949592.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: '4th of July',
                        defaultImage: [
                            '4th-of-july-american-bright-461917.jpg',
                            'agriculture-autumn-farm-164158.jpg',
                            'bright-celebration-explosion-949592.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Memorial Day',
                        defaultImage: [
                            '4th-of-july-america-flag-6895.jpg',
                            'armed-forces-army-macro-40546.jpg',
                            'aerobatics-air-air-force-372797.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Veterans Day',
                        defaultImage: [
                            '4th-of-july-america-flag-6895.jpg',
                            'armed-forces-army-macro-40546.jpg',
                            'aerobatics-air-air-force-372797.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Labor Day',
                        defaultImage: [
                            '4th-of-july-america-flag-6895.jpg',
                            'armed-forces-army-macro-40546.jpg',
                            'aerobatics-air-air-force-372797.jpg'
                        ],
                        index: 0
                    },
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'sports',
                keywords: [
                    {
                        keyword: 'Basketball',
                        defaultImage: [
                            'action-backboard-ball-358042.jpg',
                            'action-athletes-audience-269948.jpg',
                            'basketball-hoop-black-and-white-board-538694.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Baseball',
                        defaultImage: [
                            'action-athletes-ball-159741.jpg',
                            'athlete-baseball-baseball-player-163408.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Boxing',
                        defaultImage: [
                            'action-adult-athlete-598664.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Cycling',
                        defaultImage: [
                            'bicycle-bicyclist-bike-128202.jpg',
                            'action-active-activity-386024.jpg',
                            'action-adults-adventure-248547.jpg',
                            'athlete-bike-black-and-white-260409.jpg',
                            'art-bicycle-bike-623919.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Exercise',
                        defaultImage: [
                            'active-adult-athlete-863977.jpg',
                            'adult-aerobics-athlete-863974.jpg',
                            'active-activity-adult-863926.jpg',
                            'active-activity-adults-424725.jpg',
                            'enjoyment-facial-expression-fashion-1089147.jpg',
                            'active-aerobics-asian-869243.jpg',
                            'bright-close-up-color-221247.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'football',
                        defaultImage: [
                            'athlete-ball-catching-2207.jpg',
                            'action-american-football-athlete-207710.jpg',
                            'american-football-athletes-ball-159571.jpg',
                            'american-football-athlete-ball-163328.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Golf',
                        defaultImage: [
                            'activity-adult-ball-274263.jpg',
                            'activity-bunker-club-274262.jpg',
                            'game-golf-golf-club-163321.jpg',
                            'active-activity-adults-424725.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Run',
                        defaultImage: [
                            'action-athlete-athletics-618612.jpg',
                            'endurance-exercise-female-40751.jpg',
                            'dawn-dusk-exercise-347134.jpg',
                            'community-fun-group-13918.jpg',
                            'stock-photo-sport-running-jogging-run-shoe-jog-athlete-wellness-workout-57c7ea66-c573-449e-814b-b7e6468b41fd.jpg'
                        ],
                        index: 0
                    },
                    // {
                    //     keyword: 'Running',
                    //     defaultImage: [
                    //         'action-athlete-athletics-618612.jpg',
                    //         'endurance-exercise-female-40751.jpg',
                    //         'dawn-dusk-exercise-347134.jpg',
                    //         'community-fun-group-13918.jpg',
                    //         'stock-photo-sport-running-jogging-run-shoe-jog-athlete-wellness-workout-57c7ea66-c573-449e-814b-b7e6468b41fd.jpg'
                    //     ],
                    //     index: 0
                    // },
                    {
                        keyword: 'Soccer',
                        defaultImage: [
                            'athletes-field-football-532805.jpg',
                            'athlete-athletes-ball-258395.jpg',
                            'action-action-energy-american-football-906073.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Rock Climbing',
                        defaultImage: [
                            'action-adventure-challenge-449609.jpg',
                            'backpack-daylight-daytime-906013.jpg',
                            'action-active-athlete-419293.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Snow Skiing',
                        defaultImage: [
                            'action-athlete-athletes-848618.jpg',
                            'action-adventure-blue-skies-851095.jpg',
                            'equipment-ice-ski-376697.jpg',
                            'cold-daylight-enjoyment-848712.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Snowboarding',
                        defaultImage: [
                            'action-athlete-athletes-848618.jpg',
                            'action-adventure-blue-skies-851095.jpg',
                            'equipment-ice-ski-376697.jpg',
                            'cold-daylight-enjoyment-848712.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Swim',
                        defaultImage: [
                            'blue-competition-competitors-56837.jpg',
                            'action-blue-diver-863988.jpg',
                            'splash-sport-swimmer-73760.jpg',
                            'bald-goggles-leisure-50596.jpg'
                        ],
                        index: 0
                    },
                    // {
                    //     keyword: 'swimming',
                    //     defaultImage: [
                    //         'blue-competition-competitors-56837.jpg',
                    //         'action-blue-diver-863988.jpg',
                    //         'splash-sport-swimmer-73760.jpg',
                    //         'bald-goggles-leisure-50596.jpg'
                    //     ],
                    //     index: 0
                    // }
                    {
                        keyword: 'Tennis',
                        defaultImage: [
                            'pexels-photo-341003.jpeg',
                            'person-woman-sport-ball.jpg',
                            'action-active-activity-1103829.jpg',
                            'action-adult-athlete-342360.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Doubles',
                        defaultImage: [
                            'pexels-photo-341003.jpeg',
                            'person-woman-sport-ball.jpg',
                            'action-active-activity-1103829.jpg',
                            'action-adult-athlete-342360.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Yoga',
                        defaultImage: [
                            'fitness-girl-hands-374694.jpg',
                            'agility-balance-beautiful-girl-12343.jpg',
                            'active-activity-athletic-40974.jpg',
                            'active-aerobic-aerobics-917732.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Sailing',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Yatch',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Boating',
                        defaultImage: [
                            'pexels-photo-76978.jpeg',
                            'pexels-photo-42112.jpeg',
                            'pexels-photo-533595.jpeg',
                            'pexels-photo-565501.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Volleyball',
                        defaultImage: [
                            'volleyball-520093_1280.jpg',
                            'volleyball-1604584_1280.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Cheerleading',
                        defaultImage: [
                            'cheerleaders-654359_1280.jpg',
                            'cheerleaders-654381_1280.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'General',
                        defaultImage: [
                            'exercise-female-fitness-601177.jpg',
                            'adult-brunette-exercise-1089144.jpg',
                            'pexels-photo-273786.jpeg',
                            'adult-aesthetics-attractive-460520.jpg',
                            'active-adult-banana-1013329.jpg',
                            'active-activity-adult-863926.jpg',
                            'active-adult-aerobics-864939.jpg',
                            'body-exercise-fitness-176782.jpg',
                            'achievement-activity-adolescent-347135.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'family_fun_kids',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'pexels-photo-220455.jpeg',
                            'pexels-photo-296308.jpeg',
                            'pexels-photo-333529.jpeg',
                            'affection-beach-child-173666.jpg',
                            'adult-affection-baby-236220.jpg',
                            'affection-bike-child-1128318.jpg',
                            'children-cute-excited-225017.jpg',
                            'children-girls-kids-50581.jpg',
                            'baby-boys-childhood-160946.jpg',
                            'affection-baby-beautiful-1116050.jpg',
                            'adorable-adult-basket-206443.jpg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Storytime',
                        defaultImage: [
                            'pexels-photo-261889.jpeg',
                            'pexels-photo-261784.jpeg',
                            'pexels-photo-256546.jpeg',
                            'pexels-photo-261895.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Camping',
                        defaultImage: [
                            'pexels-photo-1008357.jpeg',
                            'pexels-photo-935835.jpeg',
                            'water-fight-children-water-play-51349.jpeg',
                            'pexels-photo-61129.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Camp',
                        defaultImage: [
                            'pexels-photo-1008357.jpeg',
                            'pexels-photo-935835.jpeg',
                            'water-fight-children-water-play-51349.jpeg',
                            'pexels-photo-61129.jpeg'
                        ],
                        index: 0
                    },
                    {
                        keyword: 'Summercamp',
                        defaultImage: [
                            'pexels-photo-1008357.jpeg',
                            'pexels-photo-935835.jpeg',
                            'water-fight-children-water-play-51349.jpeg',
                            'pexels-photo-61129.jpeg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        },
        {
            category: {
                name: 'singles_social',
                keywords: [
                    {
                        keyword: 'General',
                        defaultImage: [
                            'pexels-photo-814051.jpeg',
                            'acoustic-adult-band-363905.jpg',
                            'audio-close-up-club-332688.jpg',
                            'hand-hands-music-210907.jpg',
                            'band-bokeh-close-up-144428.jpg',
                            'adult-amplifier-band-375893.jpg',
                            'adult-artist-entertainment-1125744.jpg',
                            'audio-band-mixing-panel-3096.jpg',
                            'adult-artist-audience-759832.jpg',
                            'antique-close-up-drum-sticks-730656.jpg'
                        ],
                        index: 0
                    }
                ],
                index: 0
            }
        }
    ];

}






// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/services/default.images/default.category.image.web.side.ts